import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import {
  CmpTypographyField,
  CmpSelectField,
  CmpInputFieldGroup,
  CmpInputField,
  CmpStatus,
  SalesInvoiceCmpButton001,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
export default function Footer({
  vRdxWmsHead,
  xFooterObj,
  fRounding,
  xBuyer,
  sArr,
  fBuyer,
  fHeadNarration,
  xKey,
  xErrorMsg,
  fFocusRounding,
  fBlurRounding,
  fOpenDiscountPercentageModal,
  sSalesGroup,
  fSalesGroup,
  sDivision,
  fDivision,
  SingleSelect=true,
  fMultiDelete=()=>{},
  setSingleSelect=()=>{},
  setSelectedRowIds=[]
}) {
  return (
    <div className="Wms-footer">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={12} md={5} lg={5}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Division"} />
            </Grid>

            <Grid item xs={10}>
              <CmpSelectField
                xtabIndex="201"
                xLabelText="Division"
                xValue={vRdxWmsHead.Division}
                xOnChange={fDivision}
                xName={"Division"}
                xData={sDivision}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Division === "" ? false : true}
                xErrorMessage={xErrorMsg.Division}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Buyer"} />
            </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpInputField
                xValue={vRdxWmsHead.A_Buyer}
                xType={"text"} // text/number/password
                xName={"A_Buyer"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_Buyer === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Buyer}
              />
            </Grid>

            <Grid item xs={8} sm={8} md={8} lg={8}>
              <CmpSelectField
                xtabIndex="201"
                xLabelText="A_Buyername"
                xValue={vRdxWmsHead.A_Buyer}
                xOnChange={fBuyer}
                xName={"A_Buyername"}
                xData={xBuyer}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_Buyername === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Buyername}
                xDisable={false}
              />
            </Grid>
            {/* <Grid item xs={2} sm={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Sales Group"} />
            </Grid>
            <Grid item xs={10} sm={10}>
              <CmpSelectField
                xtabIndex="201"
                xLabelText="SalesGroup"
                xValue={vRdxWmsHead.salesGroup}
                xOnChange={fSalesGroup}
                xName={"salesGroup"}
                xData={sSalesGroup}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.salesGroup === "" ? false : true}
                xErrorMessage={xErrorMsg.salesGroup}
                xDisable={false}
              />
            </Grid> */}
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Narration"} />
            </Grid>
            <Grid item xs={10} sm={10} md={10} lg={10}>
              <CmpInputField
                xtabIndex="203"
                xValue={vRdxWmsHead.A_Narr}
                xType={"text"} // text/number/password
                xName={"A_Narr"}
                xReadOnly={false}
                xOnChange={fHeadNarration}
                xError={xErrorMsg.A_Narr === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Narr}
              />
            </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Department"} />
            </Grid>
            <Grid item xs={10} sm={10} md={10} lg={10}>
              <CmpInputField
                xtabIndex="203"
                xValue={vRdxWmsHead.Department}
                xType={"text"} // text/number/password
                xName={"Department"}
                xReadOnly={false}
                xOnChange={""}
                xError={xErrorMsg.Department === "" ? false : true}
                xErrorMessage={xErrorMsg.Department}
              />
            </Grid>
            {/* <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={" Credit A/c"} />
            </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpInputField
                xValue={vRdxWmsHead.A_CrAc}
                xType={"text"} // text/number/password
                xName={"A_CrAc"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_CrAc === "" ? false : true}
                xErrorMessage={xErrorMsg.A_CrAc}
              />
            </Grid>
            <Grid item xs={8} sm={8} md={8} lg={8}>
              <CmpInputFieldGroup
                xValue={vRdxWmsHead?.A_CrAcName}
                xType={"text"} // text/number/password
                xName={"A_CrAcName"}
                xReadOnly={true}
                xOnChange={""}
                // xOnKeyUp={""}
                xError={xErrorMsg.A_CrAcName === "" ? false : true}
                xErrorMessage={xErrorMsg.A_CrAcName}
              />
            </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpTypographyField xcomponent={"span"} xText={"Debit A/c"} />
            </Grid> */}
            {/* <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpInputField
                xValue={vRdxWmsHead.A_DrAc}
                xType={"text"} // text/number/password
                xName={"A_DrAc"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_DrAc === "" ? false : true}
                xErrorMessage={xErrorMsg.A_DrAc}
              />
            </Grid> */}
            {/* <Grid item xs={8} sm={8} md={8} lg={8}>
              <CmpInputFieldGroup
                xValue={vRdxWmsHead?.A_DrAcName}
                xType={"text"} // text/number/password
                xName={"A_DrAcName"}
                xReadOnly={true}
                xOnChange={""}
                // xOnKeyUp={""}
                xError={xErrorMsg.A_DrAcName === "" ? false : true}
                xErrorMessage={xErrorMsg.A_DrAcName}
              />
            </Grid> */}
            <Grid item xs={12} sm={12} md={8} lg={12} className="">
              <CmpStatus xStatus={vRdxWmsHead.A_DocStat} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3}  textAlign={"center"}>
          <Grid container  spacing={1}> 
          <Grid xs={6}  sm={12}  item>
          { SingleSelect?
            <SalesInvoiceCmpButton001
            xVariant="outlined"
              xbtnName="Single-Select"
              xOnClick={(e) => {setSingleSelect(false)}}
              // xVariant="text"
              xDisabled={false}
              xSize="small"
            />: <SalesInvoiceCmpButton001
            xVariant="outlined"
              xbtnName="Multi-Select"
              xOnClick={(e) => {
                setSingleSelect(true)
                setSelectedRowIds([])
              }}
              // xVariant="text"
              xDisabled={false}
              xSize="small"
            />}
          </Grid>
          <Grid xs={6}  sm={12}  item> 
            <SalesInvoiceCmpButton001
            xVariant="outlined"
              xbtnName="Multi-Delete"
              xOnClick={(e) => {
                fMultiDelete()
              }}
              // xVariant="text"
              xDisabled={!SingleSelect}
              xSize="small"
            />
          </Grid>
          </Grid>
         
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={4} sm={4} md={4} lg={6}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Gross & Spl.Disc.Amt"}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={xFooterObj.A_GrossAmt}
                xType={"text"} // text/number/password
                xName={"A_GrossAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={xFooterObj.A_SplDiscAmt1}
                xType={"text"} // text/number/password
                xName={"A_SplDiscAmt1"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              {/* <CmpTypographyField xcomponent={"span"} xText={"Discount"} /> */}
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Discount"}
                xonClick={fOpenDiscountPercentageModal}
                xtextDecoration="underline"
              />
            </Grid>
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              lg={2}
              // onDoubleClick={fOpenDiscountPercentageModal}
            >
              <CmpInputField
                xValue={vRdxWmsHead.A_DiscPerc}
                xType={"text"} // text/number/password
                xName={"A_DiscPerc"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>

            <Grid item xs={2} sm={2} md={2} lg={2}>
              <CmpInputField
                xValue={xFooterObj.A_TDiscAmt}
                xType={"text"} // text/number/password
                xName={"A_TDiscAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={xFooterObj.A_LDiscAmt}
                xType={"text"} // text/number/password
                xName={"A_LDiscAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>

            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"FOC Amount & Excise"}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={xFooterObj.A_FocAmt}
                xType={"text"} // text/number/password
                xName={"A_FocAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={xFooterObj.A_NetExcise}
                xType={"text"} // text/number/password
                xName={"A_NetExcise"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Rounding & Amount"}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xtabIndex="205"
                xValue={vRdxWmsHead.A_Rounding}
                xType={"number"} // text/number/password
                xName={"A_Rounding"}
                xReadOnly={false}
                xOnChange={fRounding}
                xError={xErrorMsg.A_Rounding === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Rounding}
                xonFocus={fFocusRounding}
                xonBlur={fBlurRounding}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpInputField
                xValue={xFooterObj.A_LandVal}
                xType={"text"} // text/number/password
                xName={"A_LandVal"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={4}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Tax & Net Amount"}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2.5} lg={2.5}>
              <CmpInputField
                xValue={xFooterObj.A_Tax}
                xType={"text"} // text/number/password
                xName={"A_Tax"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={2.5} lg={2.5}>
              <CmpInputField
                xValue={xFooterObj.A_Tax2}
                xType={"text"} // text/number/password
                xName={"A_Tax2"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={2} sm={2} md={3} lg={3}>
              <CmpInputField
                xValue={xFooterObj.netAmtFinal}
                xType={"text"} // text/number/password
                xName={"A_AddCess"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
